import React from "react";
import LanguageLink from "../routing/LanguageLink";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  const companyInfo = {
    name: "Citizen Hub",
    description: t("footer.company.description"),
    socialLinks: [
      {
        href: "#",
        icon: (
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
          </svg>
        ),
        label: "Twitter",
      },
      {
        href: "#",
        icon: (
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
          </svg>
        ),
        label: "Instagram",
      },
      {
        href: "#",
        icon: (
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
          </svg>
        ),
        label: "LinkedIn",
      },
    ],
  };

  const quickLinks = [
    { to: "/forms", label: t("footer.quick_links.forms") },
    { to: "/lawyer", label: t("footer.quick_links.find_lawyers") },
    // { to: "/services", label: t("footer.quick_links.our_services") },
    { to: "/faq", label: t("footer.quick_links.faq") },
    { to: "/contact", label: t("footer.quick_links.contact") },
    { to: "/blog", label: t("footer.quick_links.blog") },
  ];

  const servicesLinks = [
    { to: "/services/form-assistance", label: t("footer.services.form_assistance") },
    { to: "/services/lawyer-matching", label: t("footer.services.lawyer_matching") },
    { to: "/services/payment-processing", label: t("footer.services.payment_processing") },
    { to: "/services/legal-consultation", label: t("footer.services.legal_consultation") },
    { to: "/services/document-review", label: t("footer.services.document_review") },
    { to: "/services/case-tracking", label: t("footer.services.case_tracking") },
    { to: "/services/immigration-support", label: t("footer.services.immigration_support") },
    { to: "/services/legal-representation", label: t("footer.services.legal_representation") },
    { to: "/services/online-consultation", label: t("footer.services.online_consultation") },
  ];

  const contactInfo = {
    phone: {
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      ),
      href: "tel:+18005551234",
      text: "+1 3108802133",
    },
    email: {
      icon: (
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
      ),
      href: "mailto:info@citznhub.com",
      text: "info@citznhub.com",
    },
    support: {
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      ),
      text: t("footer.contact.support_text"),
    },
  };

  const footerBottom = {
    copyright: t("footer.bottom.copyright"),
    address: t("footer.bottom.address"),
    developedBy: {
      text: "saasbizhub.com",
      href: "https://saasbizhub.com",
    },
    poweredBy: {
      text: "codexal.co",
      href: "https://codexal.co",
    },
    legalLinks: [
      { to: "/privacy-policy", label: t("footer.bottom.legal.privacy") },
      { to: "/terms-of-service", label: t("footer.bottom.legal.terms") },
      { to: "/disclaimer", label: t("footer.bottom.legal.disclaimer") },
      { href: "/sitemap.xml", label: t("footer.bottom.legal.sitemap"), external: true },
    ],
  };

  return (
    <footer className="bg-gradient-to-br from-blue-950 via-blue-900 to-blue-950 text-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-400 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 relative z-10">
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-blue-400 to-transparent"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="space-y-6">
            <div>
              <h3 className="text-3xl font-extrabold bg-gradient-to-r from-white to-blue-200 bg-clip-text text-transparent mb-3">
                {companyInfo.name}
              </h3>
              <p className="text-sm text-blue-100 leading-relaxed opacity-90">
                {companyInfo.description}
              </p>
            </div>

            <div className="flex space-x-3">
              {companyInfo.socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  aria-label={link.label}
                  className="group relative w-11 h-11 bg-white bg-opacity-10 backdrop-blur-sm rounded-xl flex items-center justify-center hover:bg-blue-500 transition-all duration-300 hover:scale-110"
                >
                  <div className="text-blue-200 group-hover:text-white transition-colors">
                    {link.icon}
                  </div>
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6 flex items-center gap-2">
              <span className="w-1 h-6 bg-blue-400 rounded-full"></span>
              {t("footer.quick_links.title")}
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <LanguageLink
                    to={link.to}
                    className="text-blue-100 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group"
                  >
                    <span className="w-0 group-hover:w-2 h-px bg-blue-400 transition-all duration-200"></span>
                    {link.label}
                  </LanguageLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 flex items-center gap-2">
              <span className="w-1 h-6 bg-blue-400 rounded-full"></span>
              {t("footer.services.title")}
            </h4>
            <ul className="space-y-3">
              {servicesLinks.map((link, index) => (
                <li key={index}>
                  <LanguageLink
                    to={link.to}
                    className="text-blue-100 hover:text-white transition-colors duration-200 text-sm flex items-center gap-2 group"
                  >
                    <span className="w-0 group-hover:w-2 h-px bg-blue-400 transition-all duration-200"></span>
                    {link.label}
                  </LanguageLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-6 flex items-center gap-2">
              <span className="w-1 h-6 bg-blue-400 rounded-full"></span>
              {t("footer.contact.title")}
            </h4>
            <div className="space-y-4">
              {/* Phone */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white bg-opacity-10 backdrop-blur-sm rounded-lg flex items-center justify-center flex-shrink-0 text-blue-300">
                  {contactInfo.phone.icon}
                </div>
                <a href={contactInfo.phone.href} className="text-sm text-blue-100 hover:text-white transition-colors">
                  {contactInfo.phone.text}
                </a>
              </div>

              {/* Email */}
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white bg-opacity-10 backdrop-blur-sm rounded-lg flex items-center justify-center flex-shrink-0 text-blue-300">
                  {contactInfo.email.icon}
                </div>
                <a href={contactInfo.email.href} className="text-sm text-blue-100 hover:text-white transition-colors">
                  {contactInfo.email.text}
                </a>
              </div>

              {/* 24/7 Support */}
              <LanguageLink to={"/lawyer-ai"} className="flex w-full mt-6 p-4 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl">
                <div className="flex items-center gap-3">
                  <div className="text-white flex-shrink-0">{contactInfo.support.icon}</div>
                  <span className="text-white font-semibold text-sm">{contactInfo.support.text}</span>
                </div>
              </LanguageLink>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-white border-opacity-10">
          <div className="flex flex-col lg:flex-row justify-between items-center gap-6">
            <div className="text-blue-200 text-xs text-center lg:text-left">
              <p className="mb-2">{footerBottom.copyright}</p>
              <p className="mb-2">{footerBottom.address}</p>
              <p className="opacity-75">
                Developed by:{" "}
                <a href={footerBottom.developedBy.href} target="_blank" rel="noopener noreferrer" className="text-blue-300 hover:text-white transition-colors">
                  {footerBottom.developedBy.text}
                </a>{" "}
                | Powered by:{" "}
                <a href={footerBottom.poweredBy.href} target="_blank" rel="noopener noreferrer" className="text-blue-300 hover:text-white transition-colors">
                  {footerBottom.poweredBy.text}
                </a>
              </p>
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-sm">
              {footerBottom.legalLinks.map((link, index) =>
                link.external ? (
                  <a
                    key={index}
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-200 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                ) : (
                  <LanguageLink key={index} to={link.to} className="text-blue-200 hover:text-white transition-colors">
                    {link.label}
                  </LanguageLink>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;